// Mixin that deals with episdoe download function (mobile app only)

import { i18n } from '@/i18n';
import Episode from '@/models/Episode';

export default {
  methods: {
    downloadOrCancel(episode, channel) {
      if (!this.$isCordova) {
        this.$a2hs.show({force: true, message: i18n.t("downloads.mobile_app_only")});
        return;
      }
      if (this.currentUser.offline_support_disabled) {
        //show message
        this.$ons.notification.toast(i18n.t("messages.offline_support_disabled"), { timeout: 12000, animation: 'fall' });            
        return;
      }

      if ((!episode || episode._download_status !== 'DOWNLOADED') && this.showGoOnlineToast(i18n.t("messages.go_online_to_download"))) { return; }
      switch(episode._download_status) {
        case 'IDLE':
          episode.download();
          // TODO refactor
          this.updateDownloadsBadge();
          break;
        case 'PENDING':
        case 'DOWNLOADING':
          this.$ons.notification.confirm(i18n.t("downloads.cancel_confirm"), { buttonLabels: [i18n.t("ui.no"), i18n.t("ui.ok")] }).then((response) => {
            if (!response) { return; }
            episode.cancel();
            this.updateDownloadsBadge();
          });
          break;
        case 'DOWNLOADED':
          this.$ons.notification.confirm(i18n.t("downloads.delete_confirm")).then((response) => {
            if (!response) { return; }
            episode.delete();
            this.updateDownloadsBadge();
          });
          break;
        case 'FAILED':
          this.$ons.notification.confirm(i18n.t("downloads.retry_confirm")).then((response) => {
            if (!response) { return; }
            episode.download();
            this.updateDownloadsBadge();
          });
          break;
        default:
      }
    },
    updateDownloadsBadge() {
      window.setTimeout(() => {
        let downloadEpisodesCount = Episode.query().where('_download_status', value => value !== 'IDLE').count();
        if (downloadEpisodesCount === 0) {
          this.$store.commit('navigator/setDownloadsTabBadge', null);
        } else {
          this.$store.commit('navigator/setDownloadsTabBadge', `${downloadEpisodesCount}`);
        }
      }, 1000);
    },
  },
};
